import React, { SVGProps, FunctionComponent } from 'react';

import './assets/css/ContentHeader.css';

interface ContentHeaderProps {
    title: string;
    breadcrumb: string[];
    Icon?: FunctionComponent<SVGProps<SVGSVGElement>>;
}

const ContentHeader: React.FC<ContentHeaderProps> = ({ title, Icon, breadcrumb }) => {
    const RenderBreadcrumb = (obj: string, index: number, list: string[]) => {
        return (<li key={index} className="contentHeader__page">{obj}</li>);
    };

  return (
      <header className="contentHeader">
          <ul className="contentHeader__path">
            {breadcrumb.map(RenderBreadcrumb)}
		  </ul>

          <h1 className="contentHeader__title">
              {Icon ? <Icon /> : null}
            {title}
        </h1>
		</header>
    )
}

export default ContentHeader;